import classNames from 'classnames'
import { type FC, type ReactNode } from 'react'

interface MessagePanelProps {
  message: ReactNode
  variant: 'info' | 'warning'
}

const VARIANT_CONFIG: Record<MessagePanelProps['variant'], { border: string; icon: string; iconColor: string }> = {
  info: { border: 'zocks-border-primary', icon: 'bi-info-circle-fill', iconColor: 'zocks-text-primary' },
  warning: { border: 'zocks-border-color-warning-dark', icon: 'bi-exclamation-triangle-fill', iconColor: 'zocks-text-warning-dark' },
}

export const MessagePanel: FC<MessagePanelProps> = ({ message, variant }) => {
  const config = VARIANT_CONFIG[variant]
  return (
    <div className={classNames('d-flex rounded-3 gap-3 py-2 px-3', config.border)}>
      <div>
        <i className={classNames('bi fs-6', config.icon, config.iconColor)} aria-hidden='true' />
      </div>
      <div>{message}</div>
    </div>
  )
}
